import React from 'react';
import { ClockIcon, DollarSignIcon, TrendingDownIcon } from 'lucide-react';
const problems = [{
  icon: ClockIcon,
  title: 'El dinero nunca alcanza',
  description: 'Vivís contando cada peso y necesitás ingresos extra'
}, {
  icon: DollarSignIcon,
  title: 'Miedo a la inversión',
  description: 'Querés emprender pero temés perder dinero'
}, {
  icon: TrendingDownIcon,
  title: 'No sabés por dónde empezar',
  description: 'Probaste otras cosas y no funcionaron'
}];
export function NewProblemSection() {
  return <section className="bg-gradient-to-b from-gray-50 to-pink-50/30 py-16 md:py-20 px-4" data-id="element-233">
      <div className="container mx-auto max-w-5xl" data-id="element-234">
        <div className="text-center mb-12" data-id="element-235">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-236">
            ¿Te suena familiar?
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto" data-id="element-237">
            Emprender no debería ser tan complicado ni arriesgado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-238">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <article key={index} className="backdrop-blur-sm bg-white/80 rounded-2xl border border-white/20 shadow-sm p-6" data-id="element-239">
                <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center mb-4" data-id="element-240">
                  <Icon className="w-6 h-6 text-red-500" aria-hidden="true" data-id="element-241" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-242">
                  {problem.title}
                </h3>
                <p className="text-[#6B6B6B]" data-id="element-243">{problem.description}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}